import { Helmet } from "react-helmet-async";
import "./FabRegistration.css";

function FabRegistration({ organization, page, settings }) {
  const content = page?.content || {};
  const themeMode =
    String(settings?.theme_mode || "dark").trim().toLowerCase() === "light"
      ? "light"
      : "dark";


 const divisionsSectionTitle = content.divisions_section_title || "FAB Divisions";
 const locationsSectionTitle = content.locations_section_title || "SUMMER 2026 Locations & Start Dates"
 const bottomAnnouncement =
  content.bottom_announcement || "SPRING 2026 REGISTRATION NOW OPEN!!!";

 const registerSectionTitle =
  content.register_section_title || "Register Now";
 const registerSectionSubtitle =
  content.register_section_subtitle ||
  "Choose the registration path that fits you best.";


 const teamRegistrationButtonLabel =
  content.team_registration_button_label || "Team Registration";
 const teamRegistrationUrl =
  content.team_registration_url || "https://forms.gle/9XV2uybjcEhyWgT79";
 const teamRegistrationDetails =
  content.team_registration_details_text
   ?.split("\n")
   .map((line) => line.trim())
   .filter(Boolean) || [
   "1) Make a payment of team fees of $800",
   "2) Complete player registration for all players",
  ];


 const playerRegistrationButtonLabel =
  content.player_registration_button_label || "Player Registration";
 const playerRegistrationUrl =
  content.player_registration_url ||
  "https://docs.google.com/forms/d/e/1FAIpQLSebtST1fBVNYcTHKiPcYSejLX7ItQ-V7u0dAA1oAbShy8DSsg/viewform";
 const playerRegistrationDetails =
  content.player_registration_details_text
   ?.split("\n")
   .map((line) => line.trim())
   .filter(Boolean) || [];


 const freeAgentRegistrationButtonLabel =
  content.free_agent_registration_button_label || "Free Agent Registration";
 const freeAgentRegistrationUrl =
  content.free_agent_registration_url ||
  "https://docs.google.com/forms/d/e/1FAIpQLSchpRh9jIxuhGPoTMFyluiUfS4BvUakDCke_tFnVsP-qKZmkA/viewform";
 const freeAgentRegistrationDetails =
  content.free_agent_registration_details_text
   ?.split("\n")
   .map((line) => line.trim())
   .filter(Boolean) || [
   "1) Payment will be requested once a captain makes contact. Register before payment.",
   "2) Jerseys required (light & dark, unique number). Discounts from OC Imprints.",
   "Refund Policy — Free agent spots are non-refundable. Special cases credited to next season.",
  ];

 const ocImprintsUrl =
  content.oc_imprints_url || "https://www.ocimprints.com/";

 const divisionLines =
  content.divisions_text
   ?.split("\n")
   .map((line) => line.trim())
   .filter(Boolean) || [
   "Division 1 (D1) - FAB's highest competitive tier – not for the faint of heart.",
   "Division 2 (D2) - For casual players looking for vigorous competition.",
   "Division 3 (D3) - For casual players looking for less vigorous competition.",
   "Division 4 (D4) - Our Rebound league for those easing back into the game.",
   "Division 5 (D5) - Our “I just came for the free hotdog” league.",
  ];

 const locationNames =
  content.location_names_text
   ?.split("\n")
   .map((line) => line.trim())
   .filter(Boolean) || [
   "Columbus Tustin Recreation Center",
   "Columbus Tustin Recreation Center",
   "Columbus Tustin Recreation Center",
   "Irvine Valley College Hart Gymnasium",
   "Fountain Valley Recreational Center & Sports Park",
   "Fountain Valley Recreational Center & Sports Park",
  ];

 const locationSchedules =
  content.location_schedules_text
   ?.split("\n")
   .map((line) => line.trim())
   .filter(Boolean) || [
   "Tues 6–10pm",
   "Thurs 6–10pm",
   "Sat 8am–12pm",
   "Sun 6–10pm",
   "Mon 7–10pm",
   "Tues 7–10pm",
  ];

 const locationStartDates =
  content.location_start_dates_text
   ?.split("\n")
   .map((line) => line.trim())
   .filter(Boolean) || [
   "Starts 01/06/2026",
   "Starts 01/08/2026",
   "Starts 01/10/2026",
   "Starts 01/11/2026",
   "Starts 01/12/2026",
   "Starts 01/13/2026",
  ];

 const locationUrls =
  content.location_urls_text
   ?.split("\n")
   .map((line) => line.trim())
   .filter(Boolean) || [
   "https://www.google.com/maps/place/Columbus+Tustin+Recreation+Center/@33.7508854,-117.8233367,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcdbd087ed4ddf:0x2532a181a353a747!8m2!3d33.7509214!4d-117.8211428?shorturl=1",
   "https://www.google.com/maps/place/Columbus+Tustin+Recreation+Center/@33.7508854,-117.8233367,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcdbd087ed4ddf:0x2532a181a353a747!8m2!3d33.7509214!4d-117.8211428?shorturl=1",
   "https://www.google.com/maps/place/Columbus+Tustin+Recreation+Center/@33.7508854,-117.8233367,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcdbd087ed4ddf:0x2532a181a353a747!8m2!3d33.7509214!4d-117.8211428?shorturl=1",
   "https://www.google.com/maps/place/Irvine+Valley+College+Hart+Gymnasium/@33.6744695,-117.7801999,17z/data=!4m6!3m5!1s0x80dcdd0eb12fffff:0x2ba70525cbb5fec6!8m2!3d33.674551!4d-117.7776684!15sChlJcnZpbmUgVmFsbGV5IENvbGxlZ2UgR215kgEDZ3lt?shorturl=1",
   "https://www.google.com/maps/place/Fountain+Valley+Recreation+Center/@33.7251761,-117.9561271,17z/data=!3m1!4b1!4m5!3m4!1s0x80dd270954e8f7f1:0x3248bdc7e58d5982!8m2!3d33.7253283!4d-117.9539451?shorturl=1",
   "https://www.google.com/maps/place/Fountain+Valley+Recreation+Center/@33.7251761,-117.9561271,17z/data=!3m1!4b1!4m5!3m4!1s0x80dd270954e8f7f1:0x3248bdc7e58d5982!8m2!3d33.7253283!4d-117.9539451?shorturl=1",
  ];

 const parsedLocations = locationNames.map((name, index) => ({
  name,
  schedule: locationSchedules[index] || "",
  startDate: locationStartDates[index] || "",
  url: locationUrls[index] || "",
 }));
  const orgName = organization?.name || "SportingHip";
  const seoTitle = `Registration | ${orgName}`;

  const firstStartDate = parsedLocations.find((location) => location.startDate)?.startDate || "";
  const seoDescription =
    bottomAnnouncement ||
    (firstStartDate
      ? `${orgName} registration is open. ${firstStartDate}.`
      : `Register for ${orgName}. View divisions, locations, and registration details.`);

 return (
   <>
     <Helmet>
       <title>{seoTitle}</title>
       <meta name="description" content={seoDescription} />
       <meta property="og:title" content={seoTitle} />
       <meta property="og:description" content={seoDescription} />
       <meta property="og:site_name" content={orgName} />
       <link rel="canonical" href={window.location.origin + window.location.pathname} />
     </Helmet>

  <div className={`fab-registration ${themeMode}`}>
   <section className="fab-registration-section section-wrapper">
    <div className="section-content">
     <h2>{divisionsSectionTitle}</h2>

         <ul>
           {divisionLines.map((line, index) => {
             const [titlePart, ...restParts] = line.split(" - ");
             const restText = restParts.join(" - ");

             return (
               <li key={index}>
                 <strong>{titlePart}</strong>
                 {restText ? ` - ${restText}` : ""}
               </li>
             );
           })}
         </ul>
    </div>
   </section>

   <hr className="registration-divider" />

     <section className="fab-registration-section section-wrapper">
       <div className="section-content">
         <h2>{locationsSectionTitle}</h2>

         <ul className="location-list">
           {parsedLocations.map((location, index) => (
             <li key={index} className="location-line">
               {location.url ? (
                 <a
                   href={location.url}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="location-name-link"
                 >
                   {location.name}
                 </a>
               ) : (
                 <span className="location-name-text">{location.name}</span>
               )}

               <span className="location-meta">
                 {location.schedule}
                 {location.startDate ? ` ${location.startDate}` : ""}
               </span>
             </li>
           ))}
         </ul>
       </div>
     </section>

   <hr className="registration-divider" />

     <section className="fab-registration-section fab-registration-section3 section-wrapper">
       <div className="section-content register-section-content">
         <h2>{registerSectionTitle}</h2>

         <div className="register-section-right">
           <p className="register-section-subtitle">{registerSectionSubtitle}</p>

           <div className="register-info-template">
             <div className="register-card">
               <div className="register-button-wrap">
                 <a
                   href={teamRegistrationUrl}
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   <button type="button">{teamRegistrationButtonLabel}</button>
                 </a>
               </div>

               <ul>
                 {teamRegistrationDetails.map((line, index) => (
                   <li key={index}>{line}</li>
                 ))}
               </ul>
             </div>

             <div className="register-card">
               <div className="register-button-wrap">
                 <a
                   href={playerRegistrationUrl}
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   <button type="button">{playerRegistrationButtonLabel}</button>
                 </a>
               </div>

               {playerRegistrationDetails.length > 0 && (
                 <ul>
                   {playerRegistrationDetails.map((line, index) => (
                     <li key={index}>{line}</li>
                   ))}
                 </ul>
               )}
             </div>

             <div className="register-card">
               <div className="register-button-wrap">
                 <a
                   href={freeAgentRegistrationUrl}
                   target="_blank"
                   rel="noopener noreferrer"
                 >
                   <button type="button">{freeAgentRegistrationButtonLabel}</button>
                 </a>
               </div>

               <ul>
                 {freeAgentRegistrationDetails.map((line, index) => (
                   <li key={index}>
                     {line.includes("OC Imprints") ? (
                       <>
                         {line.replace("OC Imprints", "")}
                         <a
                           href={ocImprintsUrl}
                           target="_blank"
                           rel="noopener noreferrer"
                         >
                           OC Imprints
                         </a>
                         .
                       </>
                     ) : (
                       line
                     )}
                   </li>
                 ))}
               </ul>
             </div>
           </div>
         </div>
       </div>

       <div className="register-announcement-wrap">
         <h3 className="spring-announcement">{bottomAnnouncement}</h3>
       </div>
     </section>
     
  </div>
  </>
 );
}

export default FabRegistration;